export default __webpack_public_path__ + "static/media/Bladebarrier Girdle.b35fdb66.jpg";